import { FocusableOption } from '@angular/cdk/a11y';
import { ChangeDetectorRef, Directive, ElementRef, HostBinding, Input } from '@angular/core';

/* Implements role option design pattern https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/listbox_role */
@Directive()
export abstract class OptionComponentAbstract implements FocusableOption {
  /* Guarantee a unique id, code inspired from angular material */
  private static id = 0;
  private static get idCounter(): number {
    OptionComponentAbstract.id++;
    return OptionComponentAbstract.id;
  }

  readonly nativeElement: HTMLElement;

  @Input() value: unknown;
  @Input() label: string;
  @Input() disabled = false;

  private isSelected = false;

  @HostBinding('attr.aria-selected')
  @Input()
  get selected(): boolean {
    return this.isSelected;
  }
  set selected(selectedValue: boolean) {
    this.isSelected = selectedValue;
    this.cdr.markForCheck();
  }

  @HostBinding('attr.id')
  @Input()
  id = `shrd-uic-option-${OptionComponentAbstract.idCounter}`;

  @HostBinding('attr.role') role = 'option';
  @HostBinding('attr.aria-disabled')
  get isDisabled(): boolean {
    return this.disabled;
  }

  protected constructor(private readonly elRef: ElementRef, private readonly cdr: ChangeDetectorRef) {
    this.nativeElement = elRef.nativeElement;
  }

  /* Blur and focus need to be implemented by the inherited classes */
  abstract focus(): void;
  abstract blur(): void;
}
